// A code block with a copy button: commands and build snippets, never translated.
import { useState } from 'react'
import { useI18n } from '../i18n'

export function CodeBlock({
  lines,
  label,
  wrap,
}: {
  lines: string[]
  label: string
  /** Break long lines anywhere instead of scrolling (a token, which must be seen whole). */
  wrap?: boolean
}) {
  const { t } = useI18n()
  const [copied, setCopied] = useState(false)
  const style = wrap ? ({ whiteSpace: 'pre-wrap', wordBreak: 'break-all' } as const) : undefined
  return (
    <figure className="code" aria-label={label} style={{ margin: 0 }}>
      {/* biome-ignore lint/a11y/noNoninteractiveTabindex: a scrollable code block must be reachable by keyboard (WCAG 2.1.1) */}
      <pre translate="no" tabIndex={0} style={style}>
        {lines.map((l, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: fixed lines
          <span key={i} className={l.startsWith('//') || l.startsWith('#') ? 'c' : undefined}>
            {l}
            {'\n'}
          </span>
        ))}
      </pre>
      <div className="code-actions">
        <button
          type="button"
          onClick={async () => {
            await navigator.clipboard?.writeText(lines.filter((l) => !l.startsWith('#')).join('\n'))
            setCopied(true)
          }}
        >
          {copied ? t('firstRun.copied') : t('firstRun.copy')}
        </button>
      </div>
    </figure>
  )
}
